
<!-- <body> -->
<div class="sidebar">
    <div class="sidebar-brand">
        <h2>
        <img src="../../assets/images/marketingApp-logo (1).png">
</h2>
    </div>
    <div class="sidebar-menu">
        <ul>
            <li>
                <a>
                 <div class="inactive-img" (click)="click='dashboard';route()"  [ngClass]="{ 'active' : click=='dashboard' }">
                    <!-- <div>
                        <img src="../../assets/images/dashboard.svg">
                         
                    </div> -->
                    <span class="icon-report">&nbsp;&nbsp;Dashboard</span>
                </div>
                </a>
            </li>
            <li>
                <a>
                 <div class="inactive-img" (click)="click='global';route()"  [ngClass]="{ 'active' : click=='global' }">
                    <!-- <div> -->
                        <!-- <img src="../../assets/images/dashboard.svg"> -->
                         
                    <!-- </div> -->
                    <span class="icon-search">&nbsp;&nbsp;Global Search</span>
                </div>
                </a>
            </li>

            <li>
              <a>
                <div class="inactive-img" (click)="click='clients';route()"  [ngClass]="{ 'active' : click=='clients' }">
                  <!-- <div><img src="../../assets/images/staff-list.svg"></div> -->
                  <span class="icon-company">&nbsp;&nbsp;Company List</span>
                 </div>
              </a>
          </li>
          <li>
            <a>
              <div class="inactive-img" (click)="click='interested';route()"  [ngClass]="{ 'active' : click=='interested' }">
                <!-- <div><img src="../../assets/images/staff-list.svg"></div> -->
                <span class="icon-potential">&nbsp;&nbsp;Potential Cases</span>
               </div>
            </a>
        </li>
        <li >
          <a>
            <div class="inactive-img" (click)="click='mailSend';route()"  [ngClass]="{ 'active' : click=='mailSend' }">
              <!-- <div><img src="../../assets/images/reports.svg"></div> -->
              <span class="icon-mail">&nbsp;&nbsp;Mail send</span>
             </div>
          </a>
      </li>

      <li >
        <a>
          <div class="inactive-img" (click)="click='quotePending';route()"  [ngClass]="{ 'active' : click=='quotePending' }">
            <!-- <div><img src="../../assets/images/reports.svg"></div> -->
            <span class="icon-quotePending">&nbsp;&nbsp;&nbsp;Quote Pending</span>
           </div>
        </a>
    </li> 
    <li >
      <a>
        <div class="inactive-img" (click)="click='quoteSend';route()"  [ngClass]="{ 'active' : click=='quoteSend' }">
          <!-- <div><img src="../../assets/images/reports.svg"></div> -->
          <span class="icon-quoteSent">&nbsp;&nbsp;Quote send</span>
         </div>
      </a>
  </li> 
  
  <li >
    <a>
      <div class="inactive-img" (click)="click='meetingPending';route()"  [ngClass]="{ 'active' : click=='meetingPending' }">
        <!-- <div><img src="../../assets/images/reports.svg"></div> -->
        <span  class="icon-clock">&nbsp;&nbsp;Meeting  Pending</span>
       </div>
    </a>
  </li> 
  
  <li >





    <a>
      <div class="inactive-img" (click)="click='meetingScheduled';route()"  [ngClass]="{ 'active' : click=='meetingScheduled' }">
        <!-- <div><img src="../../assets/images/reports.svg"></div> -->
        <span class="icon-meeting">&nbsp;&nbsp;Meeting Scheduled</span>
       </div>
    </a>
</li> 


<li >
  <a>
    <div class="inactive-img" (click)="click='Confirmation';route()"  [ngClass]="{ 'active' : click=='Confirmation' }">
      <!-- <div><img src="../../assets/images/reports.svg"></div> -->
      <span  class="icon-confirmation">&nbsp;&nbsp;Confirmation Pending</span>
     </div>
  </a>
</li>

  
<li *ngIf=" this.storedData.userType[0].userType=='Client Admin'|| this.storedData.userType[0].userType=='Manager'">
  <a>
    <div class="inactive-img" (click)="click='clientenrolled';route()"  [ngClass]="{ 'active' : click=='clientenrolled' }">
      <!-- <div><img src="../../assets/images/staff-list.svg"></div> -->
      <span class="icon-client">&nbsp;&nbsp;Client Enrolled</span>
     </div>
  </a>
</li>

<li>
  <a>
    <div class="inactive-img" (click)="click='reminder';route()"  [ngClass]="{ 'active' : click=='reminder' }">
      <!-- <div><img src="../../assets/images/staff-list.svg"></div> -->
      <span class="icon-reminder">&nbsp;&nbsp;Reminder List</span>
     </div>
  </a>
</li>

<li *ngIf=" this.storedData.userType[0].userType=='Client Admin'|| this.storedData.userType[0].userType=='Manager'">
  <a>
    <div class="inactive-img" (click)="click='incentive';route()"  [ngClass]="{ 'active' : click=='incentive' }">
      <!-- <div><img src="../../assets/images/staff-list.svg"></div> -->
      <span      class="icon-money"        style="    font-size: 13px;
text-align: left;">&nbsp;&nbsp;&nbsp;Incentive Details</span>
     </div>
  </a>
</li>

   

<li *ngIf=" this.storedData.userType[0].userType=='Client Admin'">
  <a>
    <div class="inactive-img" (click)="click='report';route()"  [ngClass]="{ 'active' : click=='report' }">
      <!-- <div><img src="../../assets/images/reports.svg"></div> -->
      <span class="icon-re">&nbsp;&nbsp;&nbsp;Reports</span>
     </div>
  </a>
</li>



            <li *ngIf=" this.storedData.userType[0].userType=='Client Admin'">
                <a>
                 <div class="inactive-img"   (click)="click='staff';route()"  [ngClass]="{ 'active' : click=='staff' }">
                    <!-- <div> -->
                      <!-- <img src="../../assets/images/staff-list.svg" height="34px"> -->
                    <!-- </div> -->
                    <span class="icon-staffs">Staff List</span>
                </div>
                </a>
            </li>
            <li *ngIf=" this.storedData.userType[0].userType=='Client Admin'">
                <a>
                 <div class="inactive-img"   (click)="click='Disabledstaff';route()"  [ngClass]="{ 'active' : click=='Disabledstaff' }">
                    <!-- <div><img src="../../assets/images/staff-list.svg" height="34px"></div> -->
                    <span class="icon-disabled">Disabled Staff</span>
                </div>
                </a>
            </li>
            <li *ngIf=" this.storedData.userType[0].userType=='Client Admin'">
                <a>
                  <div class="inactive-img" (click)="click='products';route()"  [ngClass]="{ 'active' : click=='products' }">
                    <!-- <div><img src="../../assets/images/products.svg"></div> -->
                    <span class="icon-product">&nbsp;&nbsp;Products</span>
                   </div>
                </a>
            </li>
            <li *ngIf=" this.storedData.userType[0].userType=='Client Admin'">
                <a>
                  <div class="inactive-img" (click)="click='fields';route()"  [ngClass]="{ 'active' : click=='fields' }">
                    <!-- <div></div> -->
                    <span class="icon-home"  style="    font-size: 13px; 
text-align: left;">&nbsp;&nbsp;Custom Fields</span>
                   </div>
                </a>
            </li>
           
           <!-- <li *ngIf=" this.storedData.userType[0].userType=='Client Admin'">
                <a>
                  <div class="inactive-img" (click)="click='templates';route()"  [ngClass]="{ 'active' : click=='templates' }">
                    <span class="icon-home"  style="    font-size: 13px; 
text-align: left;">&nbsp;&nbsp;Templates</span>
                   </div>
                </a>
            </li> -->
           
          

            <!-- <li>
                <a>
                  <div class="inactive-img" (click)="click='rejected';route()"  [ngClass]="{ 'active' : click=='rejected' }">
                    <div><img src="../../assets/images/staff-list.svg"></div>
                    <span>Rejected List</span>
                   </div>
                </a>
            </li> -->

        


       
           
            
            <li >
                <a>
                  <div class="inactive-img" (click)="click='disable';route()"  [ngClass]="{ 'active' : click=='disable' }">
                    <!-- <div><img src="../../assets/images/reports.svg"></div> -->
                    <span class="icon-di">&nbsp;&nbsp;Disabled Cases</span>
                   </div>
                </a>
            </li>

            <li >
                <a>
                  <div class="inactive-img" (click)="click='templates';route()"  [ngClass]="{ 'active' : click=='templates' }">
                    <!-- <div><img src="../../assets/images/reports.svg"></div> -->
                    <span style="margin-left: 6px;"> 📮&nbsp;&nbsp;Email Templates</span>
                   </div>
                </a>
            </li>

             <li >
                <a>
                  <div class="inactive-img" (click)="click='callPerformance';route()"  [ngClass]="{ 'active' : click=='callPerformance' }">
                    <!-- <div><img src="../../assets/images/reports.svg"></div> -->
                    <span style="margin-left: 3px;"> ☎️
                      &nbsp;&nbsp;Staff Call Performance</span>
                   </div>
                </a>
            </li>
        </ul>


<div class="last-icon">

    <div class="sec-two"  (click)="this.router.navigate(['/works'])" *ngIf="this.storedData.userType[0].userType!='Client Admin'">
        <div class="log-div"><img src="../../assets/images/punchin-img.png"></div>
        <p >Punch In/Out
    </p>


        </div>  
<div class="sec-one" (click)="profile()">
<img [src]="this.storedData.photo?this.storedData.photo:'../../../../assets/images/user1.jpeg'">
<div class="user-sec">
<p style="width: 85px;font-size: 11px;">{{this.storedData.name}}</p>
<span>{{ this.storedData.userType[0].userType}}</span>
</div>
</div>
<div class="sec-two"  (click)="router.navigate(['/switch-usertype'])">
    <div class="log-div"><img src="../../assets/images/logout.png"></div>
    <p>Switch user</p>
    </div>
<div class="sec-two"  (click)="logOut()">
<div class="log-div"><img src="../../assets/images/logout.png"></div>
<p>Logout</p>
</div>
</div>


    </div>
</div>
<!-- </body> -->